<template>
  <div class="main-project-list">
    <el-row>
      <el-form
          :inline="true"
          :model="searchForm"
          class="demo-form-inline search-form"
          size="small"
      >
        <el-form-item>
          <el-input
              v-model="searchForm.examName"
              placeholder="考场名称"
              clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
              v-model="searchForm.status"
              placeholder="考场状态"
              clearable
          >
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
              type="primary"
              @click="onSearchExam"
              icon="el-icon-search"
              :loading="examPager.loading"
          >查询
          </el-button
          >
          <el-button
              v-permission="['exam:examList:exportAchievement']"
              icon="el-icon-download"
              type="primary"
              @click="onBatchExportUserExamMajorScore"
              style="margin-left: 10px"
          >成绩导出
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
          :data="examPager.list"
          v-loading="examPager.loading"
          row-key="id"
          stripe
          style="width: 100%; overflow-y: auto"
          :height="tableHeight"
          class="exam-list-table"
          @selection-change="handleExamSelectionChange">
        <el-table-column
            type="selection"
            class-name="selection-column"
            width="20">
        </el-table-column>
        <el-table-column
            prop="examName"
            label="考场名称"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            label="完成进度"
        >
          <template slot-scope="scope">
            <el-tooltip
                class="item"
                effect="dark"
                :content="`报名人数：${scope.row.userCount}，完成人数：${scope.row.finishCount}`"
                placement="top"
            >
              <el-progress :percentage="scope.row.userCount > 0 ? parseInt(scope.row.finishCount * 100 / scope.row.userCount) : 0"></el-progress>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
            prop="startTime"
            label="开始时间"
            align="center"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="endTime"
            label="结束时间"
            align="center"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="status"
            label="考场状态"
            align="center"
            :formatter="statusFormatter"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="是否公布成绩" width="150">
          <template slot-scope="scope">
            {{ {0:'否',1:'是'}[scope.row.isOpenScore] }}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="查看" width="150">
          <template slot-scope="scope">
            <table-dropdown
                :menus="[
                {
                  text: '考生信息',
                  icon: 'el-icon-s-custom',
                  permission: ['exam:examList:examUserList'],
                  fn: onExamUserList,
                  arguments: [scope.row]
                },
                {
                  text: '考场链接',
                  icon: 'el-icon-view',
                  permission: ['exam:examList:examUrl'],
                  fn: viewExamUrl,
                  arguments: [scope.row]
                },
                {
                  text: '量表详情',
                  icon: 'el-icon-view',
                  permission: ['exam:examList:examScaleList'],
                  fn: viewScale,
                  arguments: [scope.row]
                },
                {
                  text: '考场成绩导出',
                  icon: 'el-icon-download',
                  permission: ['exam:examList:exportAchievement'],
                  show: [4,5,6].includes(scope.row.status),
                  fn: exportUserExamMajorScore,
                  arguments: [scope.row]
                },
              ]"
            />
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
        class="footer"
        background
        :layout="tableLayout"
        :total="examPager.total"
        :current-page="examPager.pageNum"
        :page-size.sync="examPager.pageSize"
        @current-change="onExamPageChange"
        @size-change="handleSizeChange"
        :page-sizes="[20, 100, 500]"
        align="center"
    >
    </el-pagination>

    <el-dialog title="考场链接" :visible.sync="examUrlVisible" width="46%">
      <el-table :data="examUrls">
        <el-table-column
            prop="pcExamUrl"
            label="考场链接"
            align="center"
            show-overflow-tooltip
        ></el-table-column>

        <el-table-column fixed="right" label="二维码下载" align="center">
          <template slot-scope="scope">
            <el-tooltip
                class="item"
                effect="dark"
                content="H5端二维码"
                placement="top-start"
            >
              <el-button
                  icon="el-icon-download"
                  type="primary"
                  size="mini"
                  circle
                  @click="qrCode(null,scope.row.pcExamUrl)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div id="qrParent">
        <div id="qrCodeH5p">
          <div id="qrcodeH5"></div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="量表详情" :visible.sync="scaleVisible">
      <el-table :data="scales">
        <el-table-column
            label="量表名称"
            prop="scaleName"
            align="center"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip
                v-permission="['exam:examList:viewExamScale']"
                class="item"
                effect="dark"
                content="查看量表信息"
                placement="top-start"
            >
              <el-button
                  icon="el-icon-view"
                  type="primary"
                  size="mini"
                  @click="showScaleInfo(scope.row)"
                  circle
              ></el-button>

            </el-tooltip>
            <el-tooltip
                v-permission="['exam:examList:viewScalePaper']"
                class="item"
                effect="dark"
                content="查看试卷"
                placement="top-start"
            >
              <el-button
                  icon="el-icon-view"
                  type="primary"
                  size="mini"
                  @click="viewScaleSubject(scope.row)"
                  circle
                  :disabled="scope.row.isDel == 0"
              ></el-button>

            </el-tooltip>
            <el-tooltip
                v-permission="['exam:examList:examScaleStatistics']"
                class="item"
                effect="dark"
                content="查看统计"
                placement="top-start"
            >
              <el-button
                  icon="el-icon-view"
                  type="primary"
                  size="mini"
                  @click="viewStatistics(scope.row)"
                  :disabled="scope.row.isDel === 0"
                  circle
              ></el-button>

            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="量表信息" :visible.sync="scaleInfoVisible" width="1000px">
      <scale-view :scale-info="currentScale">
        <div slot="title" class="display-flex align-items-center">
          <span>{{currentScale.scaleName}}</span>
          <el-tag class="ml10" size="small">{{ {1: '存草稿', 2: '已发布'}[currentScale.status] }}</el-tag>
        </div>
      </scale-view>
      <el-divider>
        <el-button type="text" @click="scaleSubjectPager.open = !scaleSubjectPager.open">
          {{scaleSubjectPager.open ? '收起试题列表' : '展开试题列表'}}
          <i :class="[scaleSubjectPager.open ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"></i>
        </el-button>
      </el-divider>
      <template v-if="scaleSubjectPager.open">
        <div v-loading="scaleSubjectPager.loading">
          <subject-list
              v-if="scaleSubjectPager.list && scaleSubjectPager.list.length"
              :subjectList.sync="scaleSubjectPager.list"
              :subjectTypeOptions="subjectTypeOptions"
              :wdList="wdList"
              :pageSize="scaleSubjectPager.pageSize"
              :pageNum="scaleSubjectPager.pageNum"
              :total="scaleSubjectPager.total"
              :canCheck="false"
              :height="200 * scaleSubjectPager.list.length > 2000 ? 2000 : 200 * scaleSubjectPager.list.length"
              virtual
          >
          </subject-list>
          <empty v-else description="暂无数据"></empty>
        </div>
        <div class="page" v-if="scaleSubjectPager.list.length > 0">
          <el-pagination
              class="footer"
              background
              :layout="tableLayout"
              :current-page="scaleSubjectPager.pageNum"
              :page-size.sync="scaleSubjectPager.pageSize"
              @current-change="scaleSubjectPagerCurrentChange"
              @size-change="scaleSubjectPagerHandleSizeChange"
              :page-sizes="[20, 50, 100, 200, 500]"
              :total="scaleSubjectPager.total"
              align="center"
          >
          </el-pagination>
        </div>
      </template>
    </el-dialog>
    <el-dialog
        title="统计详情"
        :visible.sync="viewStatisticsStatus"
        width="85%"
    >
      <el-row>
        <el-form
            :inline="true"
            :model="filterField"
            size="small">
          <el-form-item>
            <el-input
                v-model="filterField.idNumber"
                placeholder="证件号码"
                clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="filterField.realName"
                placeholder="姓名"
                clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="filterField.startScore"
                placeholder="开始分数范围"
                clearable></el-input>
          </el-form-item>
          <el-form-item>
            -
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="filterField.endScore"
                placeholder="结束分数范围"
                clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
                v-model="filterField.testStatus"
                placeholder="测评状态"
                clearable>
              <el-option v-for="item in testStatusOption"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                @click="viewStatistics"
                icon="el-icon-search">查询
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-button
          v-permission="['exam:examList:exportUserScale']"
          icon="el-icon-download"
          type="primary"
          size="mini"
          @click="exportScaleRanking">导出
      </el-button>
      <el-table :data="viewStatisticsInfo.list" ref="multipleTable">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            label="用户id"
            prop="userId"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="证件号码"
            prop="username"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="用户名"
            prop="realName"
            align="center"
        ></el-table-column>
        <el-table-column
            label="性别"
            align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.sex==1">男</p>
            <p v-else-if="scope.row.sex==2">女</p>
            <p v-else>未知</p>
          </template>
        </el-table-column>
        <el-table-column
            label="分数"
            align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.score>-1">{{ scope.row.score }}</p>
            <p v-else>-</p>
          </template>
        </el-table-column>
        <el-table-column
            label="考场名"
            prop="examName"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="量表名"
            prop="scaleName"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="是否测评"
            align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.status === 1">未开始</p>
            <p v-else-if="scope.row.status === 2">进行中</p>
            <p v-else-if="scope.row.status === 3">已测评</p>
            <p v-else>未知</p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="footer"
          background
          :layout="tableLayout"
          :total="viewStatisticsInfo.total"
          :current-page="viewStatisticsInfo.pageNum"
          :page-size.sync="viewStatisticsInfo.pageSize"
          @current-change="viewStatisticsChangePage"
          @size-change="viewStatisticsSizeChange"
          :page-sizes="[20, 100, 500]"
          align="center"
      ></el-pagination>
    </el-dialog>
    <el-dialog title="考生信息详情" :visible.sync="examUserListVisible" width="90%">
      <el-row>
        <el-form
            :inline="true"
            :model="examUserForm"
            size="small">
          <el-form-item>
            <el-input
                v-model="examUserForm.realName"
                placeholder="姓名"
                clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
                v-model="examUserForm.hasIdPhoto"
                placeholder="是否有照片:"
                clearable
            >
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
                v-model="conditionValue"
                placeholder="查询条件"
                @change="changeCondition"
                :default-first-option="true"
            >
              <el-option
                  v-for="item in conditionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="conditionValue == 1">
            <el-input v-model="examUserForm.username" placeholder="账号" clearable>
            </el-input>
          </el-form-item>
          <el-form-item v-if="conditionValue == 2">
            <el-input v-model="examUserForm.mphone" placeholder="手机号" clearable>
            </el-input>
          </el-form-item>
          <el-form-item v-if="conditionValue == 3">
            <el-input v-model="examUserForm.idNumber" placeholder="证件号码" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
                v-model="conditionValue1"
                placeholder="时间范围"
                @change="changeCondition1"
                :default-first-option="true"
            >
              <el-option
                  v-for="item in conditionOptions1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  v-if="conditionValue1 == 1">
            <el-date-picker
                v-model="loginDateRange"
                clearable
                type="daterange"
                start-placeholder="登录时间开始"
                end-placeholder="登录时间结束"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="conditionValue1 == 2">
            <el-date-picker
                v-model="enterTimeRange"
                clearable
                type="daterange"
                start-placeholder="进入考场时间开始"
                end-placeholder="进入考场时间结束"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="conditionValue1 == 3">
            <el-date-picker
                v-model="accessCompleteRange"
                clearable
                type="daterange"
                start-placeholder="完成时间开始"
                end-placeholder="完成时间结束"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
                v-model="examUserForm.assessStatus"
                placeholder="考场测评状态"
                clearable>
              <el-option value="1" label="未完成" key="1"></el-option>
              <el-option value="2" label="已完成" key="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
                v-model="examUserForm.tags"
                filterable
                remote
                :remote-method="onGetTagsLike"
                :loading="loadingTagsLike"
                clearable
                placeholder="请输入关键词选择标签"
            >
              <el-option
                  v-for="item in tagsLikeList"
                  :key="item"
                  :label="item"
                  :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-button
            type="primary"
            size="mini"
            @click="onSearchExamUserList"
            icon="el-icon-search">查询
        </el-button>
        <el-button
            v-permission="['exam:examList:examUserListExport']"
            icon="el-icon-download"
            type="primary"
            size="mini"
            @click="onExamUserListExport">导出
        </el-button>
      </el-row>
      <el-table :data="examUserDetail.list" @selection-change="handleSelectionChange">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            label="姓名"
            prop="realName"
            align="center"
        ></el-table-column>
        <el-table-column
            label="是否有照片"
            align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.idPhoto ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column
            v-if="[1, 2, 3].includes(examUserForm.isIdentify)"
            label="人脸识别"
            align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.skipIdentifyCheck === 1 ? '已取消' : '已启用' }}
          </template>
        </el-table-column>
        <el-table-column
            v-if="[1, 2].includes(examUserForm.officialSubscribeType) || [1, 2].includes(examUserForm.reportOfficialSubscribeType)"
            label="公众号验证"
            align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.skipOfficialCheck === 1 ? '已取消' : '已启用' }}
          </template>
        </el-table-column>
        <el-table-column
            label="证件号码"
            prop="idNumber"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="手机号"
            prop="mphone"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="账号"
            prop="username"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="密码"
            prop="password"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="考场测评状态"
            align="center"
            width="120"
        >
          <template v-slot="{ row }">
            {{ {1: '未完成', 2: '已完成'}[row.assessStatus] }}
          </template>
        </el-table-column>
        <el-table-column
            label="登录时间"
            align="center"
            show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span class="loginDateHistoryCls" @click="showLoginDateHistory(scope.row)">{{ scope.row.loginDate }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="进入考场时间"
            prop="enterTime"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
        <el-table-column
            label="完成时间"
            prop="assessCompleteTime"
            align="center"
            show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-pagination
          class="footer"
          background
          :layout="tableLayout"
          :total="examUserDetail.total"
          :current-page="examUserDetail.pageNum"
          :page-size.sync="examUserDetail.pageSize"
          @current-change="examUserChangePage"
          @size-change="examUserSizeChange"
          :page-sizes="[20, 100, 500]"
          align="center"
      ></el-pagination>
    </el-dialog>
    <el-dialog width="60%" title="登录历史" :visible.sync="loginDateHistoryVisible">
      <el-table
          :data="loginDateHistoryPager.list"
          row-key="id"
          stripe
          style="width: 100%; overflow-y: auto">
        <el-table-column label="登录时间">
          <template slot-scope="scope">
            {{ scope.row.createDate.substring(0, 19) }}
          </template>
        </el-table-column>
        <el-table-column label="登录端点">
          <template slot-scope="scope">
            {{ { 1: 'PC端', 2: 'H5端' }[scope.row.point]}}
          </template>
        </el-table-column>
        <el-table-column prop="device" label="登录设备">
          <template slot-scope="scope">
            {{ { 'desktop': '电脑', 'tablet': '平板', 'mobile': '手机' }[scope.row.device.split(',')[0]]}} |
            {{ scope.row.device.split(',')[1] }}
          </template>
        </el-table-column>
        <el-table-column prop="ipAddress" label="IP地址">
        </el-table-column>
        <el-table-column prop="browser" label="浏览器">
        </el-table-column>
      </el-table>
      <el-pagination
          class="footer"
          background
          :layout="tableLayout"
          :total="loginDateHistoryPager.total"
          :current-page="loginDateHistoryPager.page"
          :page-size.sync="loginDateHistoryPager.pageSize"
          @current-change="onLoginDateHistoryPageChange"
          @size-change="handleLoginDateHistorySizeChange"
          :page-sizes="[20, 100, 500]"
          align="center">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {downloadScaleSubject, exportScaleRanking} from "@/api/scaleInfo";
import {getAgentTree} from "@/api/agentInfo";
import permission from "@/directive/permission"; // 权限判断指令
import {defaultPageConfig} from "@/config/pagination";
import {formatDate} from "@/utils";
import {getExamUrl} from "@/api/auth";
import QRCode from "qrcodejs2";
import {
  getExamPager,
  getExamScaleList,
  getScaleRanking,
  startOrStopExam,
  getExamScaleSubjectPager,
  exportUserExamMajorScore,
  viewExamUrl,
  getExamUserPager,
  examUserListExport,
} from "@/api/exam";
import scaleView from "@/components/scaleView";
import subjectList from "@/components/subjectList";
import empty from "@/components/empty";
import {dictionary} from "@/api/openApi";
import {getWdList} from "@/api/subjectInfo";
import {apiConfig} from "@/config/api";
import {getAgentId, getToken} from "@/utils/auth";
import {getTagsLike, loginRecordPager} from "@/api/userInfo";
import selectTree from "@/components/selectTree";

export default {
  name: "ExamList",
  components: {
    scaleView, subjectList, empty, selectTree},
  directives: {permission},
  data() {
    return {
      apiConfig: apiConfig,
      headers: {
        Authorization: getToken(),
        Authorizator: getAgentId()
      },
      filterField: {
        idNumber: '',
        realName: '',
        startScore: null,
        endScore: null,
        testStatus: null
      },
      searchForm: {
        examName: null,
        status: null,
        startDate: null,
        endDate: null,
        agentIds: [],
      },
      testStatusOption: [
        {label: "未开始", value: 1},
        {label: "进行中", value: 2},
        {label: "已测评", value: 3},
      ],
      statusOptions: [
        {label: "存草稿", value: 1},
        {label: "未开始", value: 2},
        {label: "已锁定", value: 3},
        {label: "进行中", value: 4},
        {label: "已暂停", value: 5},
        {label: "已结束", value: 6},
      ],
      examPager: {
        pageNum: 1,
        pageSize: 20,
        list: [],
        loading: false,
      },
      examAgentPager: {
        list: [],
        loading: false,
      },
      scaleSubjectPager: {
        pageNum: 1,
        pageSize: 20,
        list: [],
        loading: false,
        open: false
      },
      viewStatisticsInfo: {
        pageNum: 1,
        pageSize: 20,
        list: [],
      },
      currentScale: {},
      isSnap: 0,
      showInvigilateDialog: false,
      invigilateList: [{
        url: null,
        urlNoPrefix: null
      }],
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      examVisible: false,
      scaleInfoVisible: false,
      editExamInfoVisible: false,
      registerDate: [],
      examUrlVisible: false,
      examUrls: [],
      pcUrl: null,
      h5Url: null,
      tableHeight: 600,
      scales: [],
      scaleVisible: false,
      viewStatisticsStatus: false,
      subjectTypeOptions: [],
      subjectTypeMap: {},
      wdList: [],
      wdMap: {},
      importResetDialog: false,
      importResetParams: {
        examId: '',
        examScaleId: '',
        agentId: '',
      },
      importResetAgentList: [],
      agentTreeData: [],
      currentRow: {},
      examUserForm: {
        examId: null,
        realName: null,
        idNumber: null,
        hasIdPhoto: null,
        mphone: null,
        username: null,
        assessStatus: null,
        loginDateBegin: null,
        loginDateEnd: null,
        enterTimeBegin: null,
        enterTimeEnd: null,
        accessCompleteTimeBegin: null,
        accessCompleteTimeEnd: null,
        agentName: null,
        examUserIdList:[],
        isIdentify: null,
        officialSubscribeType: null,
        reportOfficialSubscribeType: null,
        tags: null,
      },
      examUserListVisible: false,
      examUserDetail: {
        pageNum: 1,
        pageSize: 20,
        list: [],
      },
      loginDateHistoryVisible: false,
      loginDateHistoryPager: {
        userId: '',
        page: 1,
        pageSize: 20,
        list: [],
        total: 0
      },
      conditionValue: 1,
      conditionOptions: [
        { label: "账号", value: 1 },
        { label: "手机号", value: 2 },
        { label: "证件号码", value: 3 },
      ],
      conditionValue1: 1,
      conditionOptions1: [
        { label: "登录时间", value: 1 },
        { label: "进入考场时间", value: 2 },
        { label: "完成时间", value: 3 },
      ],
      loginDateRange: [],
      enterTimeRange: [],
      accessCompleteRange: [],
      loadingTagsLike: false,
      tagsLikeList: [],
      selectExamIdList: [],
      timerArr: []
    };
  },
  watch: {
    registerDate(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0] + " 00:00:00";
        this.searchForm.endDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.startDate = null;
        this.searchForm.endDate = null;
      }
    },
    loginDateRange(val) {
      if (val && val.length > 0) {
        this.examUserForm.loginDateBegin = val[0] + " 00:00:00";
        this.examUserForm.loginDateEnd = val[1] + " 23:59:59";
      } else {
        this.examUserForm.loginDateBegin = null;
        this.examUserForm.loginDateEnd = null;
      }
    },
    enterTimeRange(val) {
      if (val && val.length > 0) {
        this.examUserForm.enterTimeBegin = val[0] + " 00:00:00";
        this.examUserForm.enterTimeEnd = val[1] + " 23:59:59";
      } else {
        this.examUserForm.enterTimeBegin = null;
        this.examUserForm.enterTimeEnd = null;
      }
    },
    accessCompleteRange(val) {
      if (val && val.length > 0) {
        this.examUserForm.accessCompleteTimeBegin = val[0] + " 00:00:00";
        this.examUserForm.accessCompleteTimeEnd = val[1] + " 23:59:59";
      } else {
        this.examUserForm.accessCompleteTimeBegin = null;
        this.examUserForm.accessCompleteTimeEnd = null;
      }
    },
  },
  created() {

  },
  activated() {
    this.searchForm = {};
    if (localStorage.getItem("pcUrl") && localStorage.getItem("h5Url")) {
      this.pcUrl = localStorage.getItem("pcUrl");
      this.h5Url = localStorage.getItem("h5Url");
    } else {
      this.getExamUrl();
    }
    this.getExamPager();
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.tableHeight =
          document.getElementsByClassName("card-fix-height")[0].clientHeight - 40;
    });
    this.initDictionary()
    this.getAgentTree();
  },
  methods: {
    setTreeMenu(key, data) {
      if (!key) {
        this.searchForm.agentIds = [];
      } else {
        this.searchForm.agentIds = key;
      }
    },
    onSearchExamUserList(){
      this.examUserForm.page = 1
      this.examUserPager(this.examUserForm)
    },
    onExamUserList(row) {
      this.examUserForm = {
        examId: null,
        realName: null,
        idNumber: null,
        mphone: null,
        username: null,
        assessStatus: null,
        loginDateBegin: null,
        loginDateEnd: null,
        enterTimeBegin: null,
        enterTimeEnd: null,
        accessCompleteTimeBegin: null,
        accessCompleteTimeEnd: null,
        agentName: null,
        examUserIdList:[],
        officialSubscribeType: null,
        reportOfficialSubscribeType: null,
        tags: null,
      }
      this.examUserForm.examId = row.id
      this.examUserForm.isIdentify = row.isIdentify
      this.examUserForm.officialSubscribeType = row.officialSubscribeType
      this.examUserForm.reportOfficialSubscribeType = row.reportOfficialSubscribeType
      this.examUserForm.page = this.examUserDetail.pageNum
      this.examUserForm.pageSize = this.examUserDetail.pageSize
      this.examUserPager(this.examUserForm)
    },
    examUserChangePage(page) {
      this.examUserForm.page = page
      this.examUserPager(this.examUserForm)
    },
    examUserSizeChange(val) {
      this.examUserForm.page = 1
      this.examUserForm.pageSize = val
      this.examUserPager(this.examUserForm)
    },
    examUserPager(data) {
      data.examUserIdList = []
      getExamUserPager(data).then(res => {
        if (res && res.code === 200) {
          this.examUserDetail = res.data
          this.examUserDetail.total = Number(res.data.total);
          this.examUserListVisible = true
        }
      })
    },
    showLoginDateHistory(row) {
      this.loginDateHistoryPager.page = 1;
      this.loginDateHistoryPager.pageSize = 20;
      this.loginDateHistoryPager.list = [];
      this.loginDateHistoryPager.total = 0;
      this.loginDateHistoryPager.userId = row.userId;
      this.loadLoginDateHistory()
      this.loginDateHistoryVisible = true
    },
    loadLoginDateHistory() {
      loginRecordPager({ userId: this.loginDateHistoryPager.userId }, {
        page: this.loginDateHistoryPager.page,
        pageSize: this.loginDateHistoryPager.pageSize,
      }).then(({ code, data }) => {
        if (code === 200) {
          this.loginDateHistoryPager.list = data.list;
          this.loginDateHistoryPager.total = Number(data.total);
        }
      })
    },
    onLoginDateHistoryPageChange() {
      this.loadLoginDateHistory();
    },
    handleLoginDateHistorySizeChange() {
      this.loginDateHistoryPager.page = 1;
      this.loadLoginDateHistory();
    },
    changeCondition() {
      this.examUserForm.mphone = null;
      this.examUserForm.idNumber = null;
      this.examUserForm.username = null;
    },
    changeCondition1() {
      this.examUserForm.accessCompleteTimeBegin = null;
      this.examUserForm.accessCompleteTimeEnd = null;
      this.examUserForm.enterTimeBegin = null;
      this.examUserForm.enterTimeEnd = null;
      this.examUserForm.loginDateBegin = null;
      this.examUserForm.loginDateEnd = null;
    },
    handleSelectionChange(val) {
      this.examUserForm.examUserIdList = []
      for (let i = 0; i < val.length; i++) {
        this.examUserForm.examUserIdList.push(val[i].id)
      }
    },
    handleExamSelectionChange(val) {
      this.selectExamIdList = []
      for (let i = 0; i < val.length; i++) {
        this.selectExamIdList.push(val[i].id)
      }
    },
    onExamUserListExport() {
      if (!this.examUserForm.examUserIdList >= 0) {
        this.$confirm(
            "您未勾选任何数据，系统将根据搜索条件进行下载, 是否继续?",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
        ).then(() => {
          this.examUserListExport(this.examUserForm);
        });
      } else {
        this.examUserListExport({
          examId: this.examUserForm.examId,
          examUserIdList: this.examUserForm.examUserIdList
        })
      }
    },
    examUserListExport(data){
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      examUserListExport(data).then((res) => {
        if (!res) {
          this.$message.error("下载文件失败");
          return false;
        }
        if (res.type && res.type.includes('application/json')) {
          let that = this;
          const reader = new FileReader();
          reader.onload = function (event) {
            const message = JSON.parse(reader.result).message;
            that.$message.error(message);
          }
          reader.readAsText(res);
          return
        }
        const blob = new Blob([res.data], {
          type: "application/octet-stream",
        });
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob);
        let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
        let result = patt.exec(contentDisposition);
        let filename = decodeURI(result[1]);
        downloadElement.style.display = "none";
        downloadElement.href = href;
        downloadElement.download = filename; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).finally(function () {
        loading.close();
      });
    },
    onGetTagsLike(query) {
      let that = this;
      if (query) {
        that.loadingTagsLike = true;
        getTagsLike({
          tag: query
        })
            .then(res => {
              if (res && res.code === 200) {
                that.tagsLikeList = res.data;
              }
            })
            .finally(() => {
              that.loadingTagsLike = false;
            });
      }
    },
    async initDictionary() {
      let subjectTypeOptionsRes = await dictionary('SUBJECT_TYPE')
      if (subjectTypeOptionsRes.code === 200) {
        this.subjectTypeOptions = subjectTypeOptionsRes.data
        for (let i = 0; i < subjectTypeOptionsRes.data.length; i++) {
          this.subjectTypeMap[subjectTypeOptionsRes.data[i].metaCode] = subjectTypeOptionsRes.data[i].metaName
        }
      }
      getWdList().then(res => {
        if (res.code === 200) {
          this.wdList = res.data;
          res.data.forEach(item => {
            this.wdMap[item.wdcode] = item.wdname
          })
        }
      })
    },
    handleSizeChange() {
      this.getExamPager();
    },
    // 格式化账户状态
    statusFormatter(row) {
      if (row.status === 2 && !row.issue) {
        return '未发布';
      }
      return {
        1: '存草稿',
        2: '未开始',
        3: '已锁定',
        4: '进行中',
        5: '已暂停',
        6: '已结束',
      }[row.status]
    },
    // 条件查询
    onSearchExam() {
      this.examPager.pageNum = 1;
      this.getExamPager();
    },
    getExamPager() {
      let that = this;
      that.examPager.loading = true;
      getExamPager(this.searchForm, {
        page: this.examPager.pageNum,
        pageSize: this.examPager.pageSize,
      })
          .then((res) => {
            if (res && res.code === 200) {
              that.examPager.total = Number(res.data.total);
              that.examPager.list = res.data.result.map((item) => {
                if (item.createDate) {
                  item.createDate = formatDate(
                      item.createDate,
                      "yyyy-MM-dd HH:mm:ss"
                  );
                }
                return item;
              });
            }
          })
          .finally(() => {
            that.examPager.loading = false;
          });
    },
    // 时间格式化
    formatTime(timestamp) {
      let date = new Date(timestamp);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return (
          [year, month, day].map(this.formatNumber).join("-") +
          " " +
          [hour, minute, second].map(this.formatNumber).join(":")
      );
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    onExamPageChange(page) {
      this.examPager.pageNum = page;
      this.getExamPager();
    },
    // 查询量表信息
    showScaleInfo(row) {
      this.currentScale = row
      this.scaleSubjectPager.pageNum = 1
      this.scaleSubjectPager.list = []
      this.loadScaleSubjectPager()
      this.scaleInfoVisible = true;
    },
    loadScaleSubjectPager() {
      this.scaleSubjectPager.loading = true
      getExamScaleSubjectPager(this.currentScale.id, {
        page: this.scaleSubjectPager.pageNum,
        pageSize: this.scaleSubjectPager.pageSize,
      }).then(res => {
        if (res && res.code === 200) {
          this.scaleSubjectPager.total = Number(res.data.total)
          this.scaleSubjectPager.list = res.data.result
        }
        this.scaleSubjectPager.loading = false
      })
    },
    scaleSubjectPagerCurrentChange(page) {
      this.scaleSubjectPager.pageNum = page;
      this.loadScaleSubjectPager();
    },
    scaleSubjectPagerHandleSizeChange(val) {
      this.scaleSubjectPager.pageSize = val
      this.scaleSubjectPager.pageNum = 1
      this.loadScaleSubjectPager()
    },
    //统计翻页
    viewStatisticsChangePage(page) {
      this.viewStatisticsInfo.pageNum = page;
      this.getStatistics();
    },
    viewStatisticsSizeChange(val){
      this.viewStatisticsInfo.pageNum = 1;
      this.viewStatisticsInfo.pageSize = val;
      this.getStatistics();
    },
    showExamInfo(row) {
      this.examPager.id = row.id;
      this.examVisible = true;
    },
    // 编辑考场草稿
    editExamDraft(row) {
      this.jumpPage({
        name: 'ExamInfo.EditDraft',
        params: { id: row.id },
      });
    },
    // 编辑机构信息
    editExamInfo(row) {
      this.examPager.id = row.id;
      this.editExamInfoVisible = true;
    },

    startOrStopExam(row) {
      startOrStopExam(row.id)
          .then((res) => {
            if (res && res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getExamPager();
            }
          })
    },
    // 跳转
    jumpPage(router) {
      this.$router.push(router);
    },
    //获取页面协议+域名
    getPageBaseUrl() {
      let baseURL = "";
      if (!window.location.origin) {
        // 兼容IE，IE11版本下location.origin为undefined
        window.location.origin =
            window.location.protocol +
            "//" +
            window.location.hostname +
            (window.location.port ? ":" + window.location.port : "");
      } else {
        baseURL = window.location.origin;
      }
      return baseURL;
    },
    viewExamUrl(row) {
      viewExamUrl(row.id).then((res) => {
        if (res && res.code === 200) {
          // console.log(res.data)
          this.examUrlVisible = true;
          this.examUrls = res.data
        }
      })
      // var codePC = this.pcUrl + "login?pd=" + row.id;
      // var codeH5 = this.h5Url + "login?examId=" + row.id + "&bind=1";
      // if (row.businessAttribute) {
      //   codePC += "&ft=" + row.businessAttribute;
      //   codeH5 += "&ft=" + row.businessAttribute;
      // }
      // this.examUrls = [
      //   {examName: row.examName, examUrl: codePC},
      //   {examName: row.examName, examUrl: codeH5},
      // ];
      // this.qrCode(codePC, codeH5);
    },
    getExamUrl() {
      getExamUrl().then((res) => {
        if (res && res.code === 200) {
          if (res.data.pcUrl) {
            localStorage.setItem("pcUrl", res.data.pcUrl);
            this.pcUrl = res.data.pcUrl;
          }
          if (res.data.h5Url) {
            localStorage.setItem("h5Url", res.data.h5Url);
            this.h5Url = res.data.h5Url;
          }
        }
      });
    },
    qrCode(codePC, codeH5) {
      document.getElementById("qrcodeH5").innerHTML = "";
      /*let qrcodePC = new QRCode("qrcodePC", {
        width: 70,
        height: 70, // 高度
        text: "" + codePC, // 二维码内容
        image: ""
        // render: "table" // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });*/
      let qrcodeH5 = new QRCode("qrcodeH5", {
        width: 70,
        height: 70, // 高度
        text: "" + codeH5, // 二维码内容
        image: "",
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
      // console.log(qrcodeH5);
      let that = this
      const loading = this.$loading({
        lock: true,
        text: "正在生成",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(()=>{
        loading.close()
        that.downloadPCQR('H5')
      },1000)
    },
    downloadPCQR(param) {
      var img;
      if (param === 'PC') {
        img = document.getElementById("qrcodePC").getElementsByTagName("img");
      } else {
        img = document.getElementById("qrcodeH5").getElementsByTagName("img");
      }
      var imgAttr = img[0].getAttribute("src");
      var qrBtn = document.createElement("a");
      qrBtn.href = imgAttr;
      qrBtn.download = param + "qr.png";
      qrBtn.click();
    },
    viewScale(row) {
      getExamScaleList({ examId: row.id }).then((res) => {
        if (res && res.code === 200) {
          this.scales = res.data;
          this.scaleVisible = true;
          this.examPager.id = row.id;
          this.isSnap = row.isSnap
        }
      });
    },
    viewScaleSubject(row) {
      window.open(
          this.pcUrl +
          "scaleHistory?examScaleId=" +
          row.id +
          "&scaleSubject=true"
      );
    },
    downloadScaleSubject(row) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let userReport = {
        userScaleId: 123,
        scaleId: row.id,
        scaleSubject: true,
      };

      downloadScaleSubject(userReport)
          .then((res) => {
            if (!res) {
              this.$message.error("下载文件失败");
              return false;
            }
            const blob = new Blob([res.data], {
              type: "application/octet-stream",
            });
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            let result = patt.exec(contentDisposition);
            let filename = decodeURI(result[1]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          })
          .finally(function () {
            loading.close();
          });
    },
    async onBatchExportUserExamMajorScore() {
      if (!this.selectExamIdList.length) {
        this.$message.error("请至少选择一个考场");
        return;
      }
      const rows = this.examPager.list.filter(v => [4,5,6].includes(v.status) && this.selectExamIdList.includes(v.id))
      if (!rows.length) {
        this.$message.error("选中的考场都未开始，请重新选择");
        return;
      }
      if (rows.length < this.selectExamIdList.length) {
        this.$message.warning("选中的数据包含未开始的考场，将忽略下载");
      }
      for (const row of rows) {
        await this.pause()
        await this.exportUserExamMajorScore(row)
      }
      this.timerArr.forEach(item => {
        clearTimeout(item)
      })
      this.timerArr = []
    },
    // 暂停1s
    pause() {
      return new Promise((resolve) => {
        let timer = setTimeout(resolve, 1000);
        this.timerArr.push(timer);  // 创建了定时器，放到一个数组中，最后将其清除掉。
      });
    },
    async exportUserExamMajorScore(row) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {examId: row.id,};
      try {
        let res = await exportUserExamMajorScore(params)
        if (!res) {
          this.$message.error("下载文件失败");
          return false;
        }
        // console.log(res)
        const blob = new Blob([res.data], {
          type: "application/octet-stream",
        });
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob);
        let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
        let result = patt.exec(contentDisposition);
        let filename = decodeURI(result[1]);
        downloadElement.style.display = "none";
        downloadElement.href = href;
        downloadElement.download = filename; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      } catch (e) {
      } finally {
        loading.close();
      }
    },
    viewStatistics(row) {
      if (row && row.id) {
        this.filterField = {
          idNumber: '',
          realName: '',
          startScore: null,
          endScore: null,
          testStatus: null
        }
        this.currentScale = row
      }
      this.viewStatisticsInfo.pageNum = 1
      this.getStatistics()
      if (!this.viewStatisticsStatus) {
        this.viewStatisticsStatus = true;
      }
    },
    getStatistics() {
      let that = this;
      getScaleRanking({
        examId: that.currentScale.examId,
        examScaleId: that.currentScale.id,
        ...this.filterField,
        page: that.viewStatisticsInfo.pageNum,
        pageSize: that.viewStatisticsInfo.pageSize,
      }).then((res) => {
        if (res && res.code === 200) {
          that.viewStatisticsInfo.list = res.data.list;
          that.viewStatisticsInfo.total = Number(res.data.total);
        }
      });
    },
    exportScaleRanking() {
      exportScaleRanking({
        examId: this.examPager.id,
        examScaleId: this.currentScale.id,
        ...this.filterField
      }).then((res) => {
        const blob = new Blob([res.data], {
          type: "application/octet-stream",
        });
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob);
        let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
        let result = patt.exec(contentDisposition);
        let filename = decodeURI(result[1]);
        downloadElement.style.display = "none";
        downloadElement.href = href;
        downloadElement.download = filename; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      });
    },
    getAgentTree() {
      let that = this;
      getAgentTree(this.searchForm, {}).then(res => {
        if (res && res.code === 200) {
          that.agentTreeData = res.data;
        }
      });
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-project-list {
  .search-form .el-form-item {
    min-width: 11.5%;
  }
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .admin-k100 {
    width: 100%;
  }
  .el-card__body {
    overflow: hidden !important;
    .el-table--enable-row-transition {
      overflow: hidden !important;
    }
  }
  ::-webkit-scrollbar {
    background-color: #f8f8ff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #dedfe9;
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 50px - 37px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
  }
  #qrParent {
    position: relative;
    height: 90px;
    /*#qrcodePCp {
      width: 100px;
      height: 80px;
      position: absolute;
      left: 180px;
      margin-top: 10px;
    }*/
    #qrCodeH5p {
      width: 100px;
      height: 80px;
      position: absolute;
      right: 360px;
      margin-top: 10px;
    }
  }
}
#myselfAgent{
  margin-right: 48px;
}
.exam-list-table {
  ::v-deep .selection-column {
    .cell {
      padding: 0;
    }
  }
}
</style>
